var map = {
	"./arrow-down.svg": [
		"b4c8",
		"chunk-2d20fcbd"
	],
	"./arrow-left-round.svg": [
		"c300",
		"chunk-2d216726"
	],
	"./arrow-left.svg": [
		"f6db",
		"chunk-2d22d604"
	],
	"./arrow-right.svg": [
		"8281",
		"chunk-2d0dd869"
	],
	"./arrow_back.svg": [
		"cf6e",
		"chunk-2d222788"
	],
	"./bubble-fill.svg": [
		"9473",
		"chunk-2d0e542d"
	],
	"./bubble.svg": [
		"d547",
		"chunk-2d21e38a"
	],
	"./calendar.svg": [
		"76b2",
		"chunk-2d0d7825"
	],
	"./camera.svg": [
		"872d",
		"chunk-2d0deaa7"
	],
	"./check.svg": [
		"4a24",
		"chunk-2d0cb6a5"
	],
	"./clock.svg": [
		"3175",
		"chunk-2d0b8eb2"
	],
	"./cloud_off.svg": [
		"c810",
		"chunk-2d217a0a"
	],
	"./comment.svg": [
		"997a",
		"chunk-2d0e6720"
	],
	"./denmark.svg": [
		"7ffa",
		"chunk-2d0e2d00"
	],
	"./document.svg": [
		"f9a1",
		"chunk-2d22e0b9"
	],
	"./download.svg": [
		"8215",
		"chunk-2d0dd794"
	],
	"./edit.svg": [
		"2dd2",
		"chunk-2d0bdf36"
	],
	"./file.svg": [
		"fe3c",
		"chunk-2d238085"
	],
	"./hexagon.svg": [
		"1697",
		"chunk-2d0ab8f9"
	],
	"./info.svg": [
		"69d9",
		"chunk-2d0d0f4e"
	],
	"./kollecto.svg": [
		"9be2",
		"chunk-2d0f066c"
	],
	"./location.svg": [
		"4093",
		"chunk-2d0bff8c"
	],
	"./locked.svg": [
		"e22b",
		"chunk-2d224c93"
	],
	"./map.svg": [
		"00fb",
		"chunk-2d0a33b2"
	],
	"./menu.svg": [
		"1f69",
		"chunk-2d0b6cce"
	],
	"./network.svg": [
		"6705",
		"chunk-2d0d017c"
	],
	"./niraslogo.svg": [
		"7c46",
		"chunk-2d0e1b84"
	],
	"./norway.svg": [
		"49fd",
		"chunk-2d0c26f9"
	],
	"./plus.svg": [
		"4eb1",
		"chunk-2d0ccb76"
	],
	"./project.svg": [
		"ac83",
		"chunk-2d213393"
	],
	"./remove.svg": [
		"a5b0",
		"chunk-2d208bf8"
	],
	"./search.svg": [
		"0a17",
		"chunk-2d0ae50d"
	],
	"./settings.svg": [
		"bc64",
		"chunk-2d21a7b5"
	],
	"./spinner.svg": [
		"9bfb",
		"chunk-2d0f06bb"
	],
	"./sweden.svg": [
		"4e34",
		"chunk-2d0cc5c8"
	],
	"./sync.svg": [
		"b88b",
		"chunk-2d2106b6"
	],
	"./united-kingdom.svg": [
		"bbce",
		"chunk-2d21a998"
	],
	"./upload.svg": [
		"cdcb",
		"chunk-2d222576"
	],
	"./user.svg": [
		"4d66",
		"chunk-2d0cc266"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f166";
module.exports = webpackAsyncContext;